import { Link } from "react-router-dom";

const navLinks = [
  { label: "Accueil", href: "/" },
  { label: "À propos", href: "/a-propos" },
  { label: "Contact", href: "/contact" },
];

const legalLinks = [
  { label: "Conditions générales", href: "/conditions-generales" },
  { label: "Politique de confidentialité", href: "/politique-de-confidentialite" },
];

export default function Footer() {
  return (
    <footer className="bg-brand-noir text-white relative overflow-hidden">
      {/* Decorative background text */}
      <div
        className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden"
        aria-hidden="true"
      >
        <span className="font-serif text-[180px] font-bold text-white/[0.02] whitespace-nowrap leading-none">
          MARCINSKI
        </span>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-8 lg:px-16 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Branding */}
          <div className="lg:col-span-2">
            <img
              src="https://public.readdy.ai/ai/img_res/be183dea-b8b4-4fc4-b8c3-703c3fe9bf21.png"
              alt="MARCINSKI Logo"
              className="h-12 w-auto object-contain mb-6 brightness-0 invert"
            />
            <p className="font-sans text-sm text-brand-gris-light leading-relaxed mb-6 max-w-xs">
              Studio de design créatif spécialisé en identité visuelle et branding à Bordeaux.
            </p>
            <div className="font-sans text-sm text-brand-gris-light leading-loose">
              <p>Oskar Arkadiusz Marcinski</p>
              <p>SIRET : 101 116 994 00019</p>
              <p className="mt-2">37 Rue Lecocq</p>
              <p>33000 Bordeaux, France</p>
              <a href="mailto:oskarmarcinsk1@inbox.eu" className="block mt-3 text-brand-or hover:text-white transition-colors duration-300 cursor-pointer">
                oskarmarcinsk1@inbox.eu
              </a>
              <a href="tel:+33758860574" className="block mt-1 text-brand-or hover:text-white transition-colors duration-300 cursor-pointer">
                +33 7 58 86 05 74
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-sans text-xs tracking-widest uppercase text-brand-gris-light mb-6">
              <a href="#navigation">Navigation</a>
            </h4>
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="font-sans text-sm text-white/70 hover:text-brand-or transition-colors duration-300 cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-sans text-xs tracking-widest uppercase text-brand-gris-light mb-6">
              <a href="#legal">Légal</a>
            </h4>
            <nav className="flex flex-col gap-4">
              {legalLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="font-sans text-sm text-white/70 hover:text-brand-or transition-colors duration-300 cursor-pointer"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col lg:flex-row items-center justify-between gap-4">
          <p className="font-sans text-xs text-white/30 tracking-wider">
            © {new Date().getFullYear()} MARCINSKI. Tous droits réservés.
          </p>
          <p className="font-sans text-xs text-white/30 tracking-wider">
            74.10Z – Activités spécialisées de design
          </p>
        </div>
      </div>
    </footer>
  );
}
